<template>
  <div class="auth-card-wrapper">
    <div class="auth-card">
      <div class="auth-card-container">
        <img
          class="logo auth-logo"
          alt="Continuum Design"
          src="/continuum-design-logo.svg"
        />
        <h3 class="text-title mb-2">Reset password</h3>
        <p class="reset-password-description">If you have an account, you will receive a verification<br/>
          code by email that you can use to set a new password.
        </p>
      </div>

      <v-form ref="form" v-model="valid">
        <div class="auth-card-container form-fields" style="margin-bottom: 8px">
          <v-text-field
            label="Email"
            type="email"
            v-model="username"
            :rules="[rules.required, rules.email]"
            validate-on="blur"
            v-on:keydown.enter="submit"
            autofocus
            variant="outlined"
            density="default"
          ></v-text-field>

          <p class="message bg-error" v-if="error">{{ error }}</p>
          <p class="message bg-indigo" v-if="message">{{ message }}</p>

          <div class="d-flex justify-center auth-card-container">
            <v-btn rounded="lg" size="large" color="primary" class="d-flex" variant="flat" @click="submit"
                   tabindex="3">
              Request reset password
            </v-btn>
          </div>

          <v-divider></v-divider>

          <div class="auth-card-footer-part">
            <div class="auth-card-footer">
              <p class="text">
                No account?
                <router-link
                  class="text text-decoration-none"
                  tabindex="5"
                  :to="{ path: '/login'}"
                >
                  <span class="light--text">Login</span>
                </router-link>
              </p>
            </div>
          </div>
        </div>
      </v-form>
    </div>
  </div>
</template>

<script>
import { authProxyApi } from '@/api/authProxyApi'

export default {
  data () {
    return {
      username: '',
      error: null,
      valid: true,
      message: null,
      rules: {
        required: (value) => !!value || 'Required.',
        email: (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        }
      }
    }
  },
  methods: {
    async submit (event) {
      event.preventDefault()
      this.error = null
      this.message = null
      const { valid } = await this.$refs.form.validate()
      if (valid) {
        // Enumeration-safe flow: always behave the same way.
        const start = Date.now()
        const minDelayMs = 800

        const email = (this.username || '').toLowerCase()

        let response = null
        try {
          response = await authProxyApi.forgotPassword({ email })
        } catch (err) {
          console.error('Forgot password failed:', err)
        }

        const remaining = minDelayMs - (Date.now() - start)
        if (remaining > 0) {
          await new Promise(resolve => setTimeout(resolve, remaining))
        }

        // Cognito refuses to send a reset code when the email isn't verified.
        // Route to /confirm to verify first; intent=reset brings them back here.
        if (response?.code === 'EMAIL_NOT_VERIFIED') {
          this.$router.replace({
            path: '/confirm',
            query: { username: email, autoResend: true, intent: 'reset' }
          })
          return
        }

        this.$router.replace({ path: '/confirm-reset-password', query: { username: email } })
      }
    }
  }
}
</script>

<style scoped>
.text {
  color: var(--text-dark);
  font-size: 13px;
  text-align: left;
  margin-bottom: 0;
  line-height: 14.3px;
}

.logo {
  width: 180px;
  margin-bottom: 24px;
}

.form-fields {
  gap: 12px;
  display: flex;
  flex-direction: column;
}

.message {
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 16px;
}

[data-theme="dark"] a,
[data-theme="dark"] a .light--text {
  color: var(--blue-1);
}
</style>
